import { z } from 'zod';
import { todayInTimezone } from '../dates';
import { emptyAsUndefined, id, optionalText, requiredId, ymd } from './common';

const notFuture = (v: string | undefined) => v === undefined || v <= todayInTimezone();

/**
 * Move a prepaid ads account onto a manager account's (MCC's) credit line from
 * a date. Spend before that date stays prepaid; spend from it uses the credit line.
 */
export const convertToCreditLineSchema = z.object({
  managerAccountId: requiredId('Manager account'),
  /** First day billed on the credit line (default: today). */
  effectiveFrom: emptyAsUndefined(ymd).refine(notFuture, 'The date cannot be in the future'),
  notes: optionalText(2000),
});
export type ConvertToCreditLineInput = z.output<typeof convertToCreditLineSchema>;

/** Record what happened to the prepaid balance left at conversion (refund, used, written off). */
export const settlePrepaidBalanceSchema = z.object({
  /** Empty clears it (the balance shows as open again). */
  settledOn: emptyAsUndefined(ymd).refine(notFuture, 'The date cannot be in the future'),
  note: optionalText(500),
});
export type SettlePrepaidBalanceInput = z.output<typeof settlePrepaidBalanceSchema>;

export const billingChangeParams = z.object({ id, changeId: id });
